module.exports = {
  "slider-bar-container": {
    "justifyContent": "center",
    "alignItems": "center",
    "overflow": "hidden"
  },
  "range-bar": {
    "overflow": "hidden"
  },
  "value-bar": {
    "height": "4",
    "overflow": "hidden"
  },
  "slide-block": {
    "width": "44",
    "height": "44",
    "backgroundColor": "#ffffff",
    "borderRadius": 50,
    "borderWidth": "1",
    "borderColor": "rgba(0,0,0,0.1)",
    "position": "absolute",
    "left": 0,
    "bottom": "10",
    "boxShadow": "2px 3px 3px #999"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5bb74680!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-slider-bar/index.vue
// module id = 497
// module chunks = 0 1